import React, { useState, useEffect, useRef } from 'react';

import { Link } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faEnvelope, faMessage, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table } from 'react-bootstrap';
import Trash from '../../../../assets/images/trash.png';
import Docmnt from "../../../../assets/images/google-docs.png";
import message_icon from "../../../../assets/images/Message_2.png";
import file_download from "../../../../assets/images/file_download.png";
import view from "../../../../assets/images/view.svg";
import flag_icon from "../../../../assets/images/flag.png";
import email from "../../../../assets/images/email.png";
import mail_send from "../../../../assets/images/mail_send.png";

import { saveAs } from "file-saver";
import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { CallApi, getTodayDate } from '../../../../Components/common/CommonFunctions.js';
import DetailsModal from '../../../../Components/common/DetailsModal.js';

const Stations = ({ allData, spec, cat, sol, onChildAction, onTab }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState([]);
    const [activeEditId, setActiveEditId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState('');

    useEffect(() => {
        // const newAspect = { warehouse_check: false, warehouse_check_date: '', contacted_agent: false, contacted_agent_date: '' };
        const newAspect = {
            warehouse_check: false, warehouse_check_date: '', spot_check: false, spot_check_date: '',
            agent_check: false, agent_check_date: '', cctv_check: false, cctv_check_date: '',
        };
        const transData = allData?.stations?.map(prev => ({
            ...prev,
            handler_action: prev.handler_action.length == 0 ? [...prev.handler_action, newAspect] : prev.handler_action,
            // handler_action: prev.handler_action,
            attachments: prev.attachments || [],
            files: [],
            showFiles: [],
            storage_location: prev.storage_location || '',
            acceptance_time: prev.acceptance_time || '',
            buildup_time: prev.buildup_time || ''
        }))
        setFormData(transData)
    }, [allData])

    const handleFormChange = (hfId, fieldName, value) => {

        setFormData(prevFormData => prevFormData.map(hndlr => {
            if (hndlr.handler_feedback_id === hfId) {
                return { ...hndlr, [fieldName]: value };
            }
            return hndlr;
        }));
        // const { name, value } = event.target;
        // const updatedData = { ...formData, [name]: value };
        // setFormData(updatedData);
    };

    const CHECK_DATE_MAP = {
        warehouse_check: 'warehouse_check_date',
        spot_check: 'spot_check_date',
        agent_check: 'agent_check_date',
        cctv_check: 'cctv_check_date',
    };

    const handleInputChange = (hfId, index, field, value) => {

        // setRecoveryAspects(updatedAspects);
        // setFormData(prevFormData => prevFormData.map(hndlr => {
        //     if (hndlr.handler_feedback_id === hfId) {
        //         const updatedAction = { ...hndlr.handler_action[index], [field]: value };
        //         const updatedAspects = [...hndlr.handler_action];
        //         updatedAspects[index] = updatedAction;

        //         return { ...hndlr, handler_action: updatedAspects };
        //     }
        //     return hndlr;
        // }));

        // setFormData(prev => ({
        //     ...prev,
        //     handler_action: updatedAspects
        // }));
        setFormData(prev =>
            prev.map(hndlr => {
                if (hndlr.handler_feedback_id !== hfId) return hndlr;

                const actions = [...hndlr.handler_action];
                const action = { ...actions[index], [field]: value };

                const dateField = CHECK_DATE_MAP[field];

                if (dateField) {
                    if (value && !action[dateField]) {
                        action[dateField] = getTodayDate();
                    } else if (!value) {
                        action[dateField] = '';
                    }
                }

                actions[index] = action;
                return { ...hndlr, handler_action: actions };
            })
        );
    };

    const handleMsgTab = (sec) => {
        onTab({ tab: 'msg', goTo: sec })
    }

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }

    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        console.log('path', path);

        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: imageUrl,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };

    const handleEditToggle = async (station) => {
        const serviceRecoveryId = allData?.service_recovery_id;
        if (activeEditId !== station.handler_feedback_id) {
            setActiveEditId(station.handler_feedback_id);
            return;
        }
        const payload = {
            station: [
                {
                    ...station,
                    pieces_traced: station.pieces_traced ?? '',
                    tracing_date: station.tracing_date ?? '',
                    handler_action: station.handler_action ?? [],
                    storage_location: station.storage_location ?? '',
                    acceptance_time: station.acceptance_time ?? '',
                    buildup_time: station.buildup_time ?? ''
                }
            ],
            service_recovery_id: serviceRecoveryId
        };
        console.log("payload", payload)
        try {
            setIsLoading(true);
            const res = await withRFSToken.post('service-recovery/update', payload);
            if (res?.data?.response_code === 200) {
                toast.success('Station updated');
                setActiveEditId(null);
                onChildAction?.();
            } else {
                toast.error(res?.data?.response_msg || 'Update failed');
            }
        } catch (error) {
            console.error("Error updating station:", error);
            toast.error('Unable to update station');
        } finally {
            setIsLoading(false);
        }
    };

    const fetchTraced = (stn) => {
        CallApi({
            endPoint: 'handler-feedback/traced-history',
            payload: { service_recovery_id: allData.service_recovery_id, type: 'warehouse', handler_feedback_id: stn.handler_feedback_id },
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    const innerData = data.data.response_data;
                    setModalData({ ...stn, trc: innerData, pos: 'V' })
                    setIsModalOpen(true)
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    };

    const handleModalOpen = (stn, pos) => {
        if (pos === 'V') {
            fetchTraced(stn)
        } else {
            setModalData({
                ...stn,
                pos: pos
            })
            setIsModalOpen(true)
        }
    }
    const handleModalClose = () => {
        setIsModalOpen(false)
        setModalData('')
    }
    const handleAspects = (dta) => {
        { console.log('dta', dta) }
        // setFormData(prev => prev.map(stn => {
        //     if (stn.handler_feedback_id === dta.handler_feedback_id) {
        //         stn.handler_action = dta.handler_action
        //     }
        //     return stn;
        // }))
        setFormData(prev => prev.map(stn =>
            stn.handler_feedback_id === dta.handler_feedback_id
                ? {
                    ...stn,
                    breakdown: dta.breakdown,
                    location: dta.location,
                    acceptance_time: dta.acceptance_time,
                    storage_location: dta.storage_location,
                    buildup_time: dta.buildup_time
                }
                : stn
        ))
    }

    return (
        <>
            {/* {isLoading ?
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                : */}
            {console.log('formData', formData)}
            {console.log('modalData', modalData)}
            {isModalOpen &&
                <DetailsModal
                    loadData={modalData}
                    onSave={handleAspects}
                    closeModal={handleModalClose}
                    pos={modalData.pos}
                />
            }
            <Row>
                {formData?.filter(stn => stn.handler_type !== "Airline").map((stn, index) => {
                    const rtdHandler = stn.handler_type === 'Reported';
                    const sameHandlerId = rtdHandler && formData.some(item => item.handler_id === stn.handler_id);
                    if (sameHandlerId) return null;
                    const rtdStn = ['Origin', 'Destination'].includes(stn.handler_type) && formData.find(item => item.handler_type === 'Reported' && item.handler_id === stn.handler_id)

                    const attHandler = allData?.attachments?.filter(
                        (att) => att.uploaded_by_org_id === stn.org_id
                    );
                    const isEditing = activeEditId === stn.handler_feedback_id;
                    return (
                        <Col sm={4} className={stn?.isEditable ? 'reported' : ''}>
                            <div className='flbg mb-3 h-100'>
                                <div className='ship_head station_shipHead'>
                                    <h4 className='d-flex w-100 align-items-center justify-content-between ps-4'>
                                        {stn?.handler_type} - {stn.station_name}
                                        <span className={stn.recovery_status === 'Closed' ? 'record_red' : 'record_status'}></span>
                                        <span>
                                        {rtdStn && <span><img src={flag_icon} title='Reported by' /></span>}
                                        {stn?.isEditable && (
                                            <button type='button' className='serv_edit_save ms-2' onClick={() => handleEditToggle(stn)} disabled={isLoading}>
                                                <FontAwesomeIcon icon={faPencilAlt} className='pe-1' />
                                                {isEditing ? 'Save' : 'Edit'}
                                            </button>
                                        )}
                                        </span>
                                    </h4>
                                </div>
                                <div className='recover_box mb-2' key={index}>
                                    <div className='d-flex justify-content-between align-items-center up_reco_status'>
                                        <div className='reco_left'>
                                            <h4>Handler Name</h4>
                                            <p>{stn.handler_name}</p>
                                        </div>
                                        <div>
                                            <div className='reco_right'>
                                                <Link to='#' onClick={() => handleMsgTab(stn.station_name)}><img src={mail_send} alt='email' className='station_email_icon' /></Link>
                                                {/* <Link><img src={category_icon} alt='category_icon' className='station_category_icon' /></Link> */}
                                            </div>
                                            <div className='reco_middle'>
                                                <span className={stn.pieces_traced == null ? '' : stn.pieces_traced == allData.pieces_involved ? 'serv_trace_gr' : 'serv_trace_org'}>
                                                    {stn.pieces_traced == null ? 'No Response' : stn.pieces_traced == allData.pieces_involved ? 'All Completed' : `${stn.pieces_traced}/${allData.pieces_involved} Pcs Traced`}</span>

                                            </div>
                                        </div>
                                        {/* <div className='reco_middle'>
                                                <span className={stn.pieces_traced == null ? '' : stn.pieces_traced == allData.pieces_involved ? 'serv_trace_gr' : 'serv_trace_org'}>
                                                    {stn.pieces_traced == null ? 'No Response' : stn.pieces_traced == allData.pieces_involved ? 'All Completed' : `${stn.pieces_traced}/${allData.pieces_involved} Pcs Traced`}</span>

                                            </div>
                                            <div className='reco_right'>
                                                <Link to='#' onClick={() => handleMsgTab(stn.station_name)}><img src={message_icon} alt='message_icon' /></Link>
                                            </div> */}
                                    </div>
                                </div>
                                <Form.Group as={Row} className="mb-1">
                                    <Col >
                                        <Form.Label>Pieces Traced</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder=""
                                            name='pieces_traced'
                                            value={stn.pieces_traced || ''}
                                            disabled={!isEditing}
                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'pieces_traced', e.target.value)}
                                        />
                                    </Col>
                                    <Col >
                                        <Form.Label>Tracing Date </Form.Label>
                                        <Form.Control
                                            type="date"
                                            placeholder=""
                                            name='tracing_date'
                                            value={stn.tracing_date || ''}
                                            disabled={!isEditing}
                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'tracing_date', e.target.value)}

                                        />
                                    </Col>
                                </Form.Group>
                                {stn?.isEditable &&
                                    <div className='specific_box'>
                                        <Form.Group className='mb-2'>
                                            <Form.Label>Short Description </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                name='description'
                                                value={stn.description || ''}
                                                onChange={(e) => handleFormChange(stn.handler_feedback_id, 'description', e.target.value)}
                                                placeholder="Short Description"
                                                style={{ height: '150px' }}
                                                disabled={!isEditing}
                                            />
                                        </Form.Group>

                                        <Form.Group className='mb-2'>
                                            <Form.Label>Specification <span>*</span></Form.Label>
                                            <Select
                                                options={spec}
                                                className="basic-multi-select"
                                                value={spec.filter(opt => stn.specification?.includes(opt.value))}
                                                onChange={(selectedOptions) => {
                                                    const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                    handleFormChange(stn.handler_feedback_id, 'specification', values);
                                                }}
                                                placeholder="Select"
                                                isDisabled={!isEditing}
                                                isMulti
                                            />
                                        </Form.Group>
                                        <Form.Group className='mb-2'>
                                            <Form.Label>Solution <span>*</span></Form.Label>
                                            <Select
                                                options={sol}
                                                className="basic-multi-select"
                                                value={sol.filter(opt => stn.solution_id?.includes(opt.value))}
                                                onChange={(selectedOptions) => {
                                                    const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                                                    handleFormChange(stn.handler_feedback_id, 'solution_id', values);
                                                }}
                                                placeholder="Select"
                                                isDisabled={!isEditing}
                                                isMulti
                                            />
                                        </Form.Group>
                                    </div>
                                }

                                <div className='mt-3 recovery_aspect'>
                                    <div className='d-flex actbtn_side justify-content-between'>
                                        <p className=' bg-transparent'><Button className='w-100 text-primary text-start'>Recovery Aspects</Button></p>
                                        <Button className={`me-2 ${stn?.isEditable ? '' : 'd-none'}`}><img src={view} onClick={() => handleModalOpen(stn, 'V')} /></Button>
                                    </div>
                                    {/* <hr className='m-0' /> */}
                                    <Form.Group className="mb-1 mt-1">
                                        {stn?.handler_action?.map((aspect, index) => (
                                            <React.Fragment key={index}>
                                                <Row>
                                                    <Col className='mb-1 pe-0'>
                                                        <div className='warehose bg-transparent border-0'>
                                                            <Form.Label>Warehouse Check</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="warehouse_check_date"
                                                                value={aspect.warehouse_check_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col className='mb-1 position-relative ps-0'>
                                                        <div className='warehose bg-transparent border-0'>
                                                            <Form.Label>Spot Check</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="spot_check_date"
                                                                value={aspect.spot_check_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'spot_check_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='mb-1 pe-0'>
                                                        <div className='warehose bg-transparent border-0'>
                                                            <Form.Label>Agent Check</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="agent_check_date"
                                                                value={aspect.agent_check_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'agent_check_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col className='mb-1 position-relative ps-0'>
                                                        <div className='warehose bg-transparent border-0'>
                                                            <Form.Label>CCTV Check</Form.Label>
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="cctv_check_date"
                                                                value={aspect.cctv_check_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'cctv_check_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </React.Fragment>
                                        ))}
                                    </Form.Group>
                                </div>
                                <div className='mt-3 recovery_aspect'>
                                    <div className='d-flex actbtn_side justify-content-between'>
                                        <p className=' bg-transparent'><Button className='w-100 text-primary text-start' disabled={!isEditing} onClick={() => handleModalOpen(stn, 'W')}>Warehouse Details</Button></p>
                                        <Button className={`me-2 ${stn?.isEditable ? '' : 'd-none'}`} disabled={!isEditing} onClick={() => handleModalOpen(stn, 'W')}><img src={view} /></Button>
                                    </div>

                                    {/* <hr className='mt-0' /> */}
                                </div>

                                {/* {stn?.isEditable &&
                                        <div className='d-flex actbtn_side justify-content-between'>
                                            <p style={{ background: '#80b1de' }}><Button className='w-100'>Recovery Aspects</Button></p>
                                            <Button><img src={view} onClick={() => handleModalOpen(stn, 'V')} /></Button>
                                        </div>
                                    } */}
                                <Form.Group className="mb-1 mt-2 d-none">
                                    <Row>
                                        {stn?.handler_action?.map((aspect, index) => (
                                            <React.Fragment key={index}>
                                                {aspect.warehouse_check &&
                                                    <Col sm={6} className='mb-2'>
                                                        <div className='warehose'>
                                                            Warehouse Check <br />
                                                            <Form.Label>{aspect.warehouse_check_date}</Form.Label>
                                                        </div>
                                                    </Col>
                                                }
                                                {aspect.spot_check &&
                                                    <Col sm={6} className='mb-2 position-relative'>
                                                        <div className='warehose'>
                                                            Spot Check <br />
                                                            <Form.Label>{aspect.spot_check_date}</Form.Label>
                                                        </div>
                                                    </Col>
                                                }
                                                {aspect.agent_check &&
                                                    <Col sm={6} className='mb-2'>
                                                        <div className='warehose'>
                                                            Agent Check <br />
                                                            <Form.Label>{aspect.agent_check_date}</Form.Label>
                                                        </div>
                                                    </Col>
                                                }
                                                {aspect.cctv_check &&
                                                    <Col sm={6} className='mb-2 position-relative'>
                                                        <div className='warehose'>
                                                            CCTV Check <br />
                                                            <Form.Label>{aspect.cctv_check_date}</Form.Label>
                                                        </div>
                                                    </Col>
                                                }
                                            </React.Fragment>
                                        ))}
                                    </Row>
                                </Form.Group>
                                <div>
                                    {/* <Form.Label>Recovery Aspects </Form.Label> */}
                                    <Form.Group className="mb-1 mt-2 d-none">
                                        <Row>
                                            {stn?.handler_action?.map((aspect, index) => (
                                                <React.Fragment key={index}>
                                                    {aspect.warehouse_check &&
                                                        <Col sm={6} className='mb-2'>
                                                            <div className='warehose'>
                                                                <Form.Check
                                                                    inline
                                                                    type="checkbox"
                                                                    id={`warehouseCheck${index}`}
                                                                    className="warehouse_check"
                                                                    label='Warehouse Check'
                                                                    checked={aspect.warehouse_check}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check', e.target.checked)}
                                                                />
                                                                <Form.Control
                                                                    type="date"
                                                                    placeholder=""
                                                                    name="warehouse_check_date"
                                                                    value={aspect.warehouse_check_date}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check_date', e.target.value)}
                                                                />
                                                            </div>
                                                        </Col>
                                                    }
                                                    {aspect.spot_check &&
                                                        <Col sm={6} className='mb-2 position-relative'>
                                                            <div className='warehose'>
                                                                <Form.Check
                                                                    inline
                                                                    type="checkbox"
                                                                    id={`spotcheck${index}`}
                                                                    className="spot_check"
                                                                    label='Spot Check'
                                                                    checked={aspect.spot_check}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'spot_check', e.target.checked)}
                                                                />
                                                                <Form.Control
                                                                    type="date"
                                                                    placeholder=""
                                                                    name="spot_check_date"
                                                                    value={aspect.spot_check_date}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'spot_check_date', e.target.value)}
                                                                />
                                                            </div>
                                                        </Col>
                                                    }
                                                    {/* </Row>
                                                    <Row> */}
                                                    {aspect.agent_check &&
                                                        <Col sm={6} className='mb-2'>
                                                            <div className='warehose'>
                                                                <Form.Check
                                                                    inline
                                                                    type="checkbox"
                                                                    id={`agentcheck${index}`}
                                                                    className="agent_check"
                                                                    label='Agent Check'
                                                                    checked={aspect.agent_check}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'agent_check', e.target.checked)}
                                                                />
                                                                <Form.Control
                                                                    type="date"
                                                                    placeholder=""
                                                                    name="agent_check_date"
                                                                    value={aspect.agent_check_date}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'agent_check_date', e.target.value)}
                                                                />
                                                            </div>
                                                        </Col>
                                                    }
                                                    {aspect.cctv_check &&
                                                        <Col sm={6} className='mb-2 position-relative'>
                                                            <div className='warehose'>
                                                                <Form.Check
                                                                    inline
                                                                    type="checkbox"
                                                                    id={`cctvcheck${index}`}
                                                                    className="cctv_check"
                                                                    label='CCTV Check'
                                                                    checked={aspect.cctv_check}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'cctv_check', e.target.checked)}
                                                                />
                                                                <Form.Control
                                                                    type="date"
                                                                    placeholder=""
                                                                    name="cctv_check_date"
                                                                    value={aspect.cctv_check_date}
                                                                    disabled={!isEditing}
                                                                    onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'cctv_check_date', e.target.value)}
                                                                />
                                                            </div>
                                                        </Col>
                                                    }

                                                    {/* <Col className='mb-2'>
                                                        <div className='warehose'>
                                                            <Form.Check
                                                                inline
                                                                type="checkbox"
                                                                id={`warehouseCheck${index}`}
                                                                className="warehouse_check"
                                                                label={`Warehouse Check - ${index + 1}`}
                                                                checked={aspect.warehouse_check}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check', e.target.checked)}
                                                            />
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="warehouse_check_date"
                                                                value={aspect.warehouse_check_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col className='mb-2 position-relative'>
                                                        <div className='warehose'>
                                                            <Form.Check
                                                                inline
                                                                type="checkbox"
                                                                id={`contactedAgent${index}`}
                                                                className="warehouse_check"
                                                                label={`Contacted Agent - ${index + 1}`}
                                                                checked={aspect.contacted_agent}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'contacted_agent', e.target.checked)}
                                                            />
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="contacted_agent_date"
                                                                value={aspect.contacted_agent_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'contacted_agent_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col> */}
                                                </React.Fragment>
                                            ))}
                                        </Row>
                                    </Form.Group>
                                </div>
                                {/* <hr /> */}
                                <div className="accordion ship_head_wrap mt-3 d-none" id="wdAccordion">

                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="wdetails">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#${index}_wdetails`}
                                                aria-expanded="false"
                                                aria-controls={`${index}_wdetails`}
                                            >
                                                Warehouse Details
                                            </button>
                                        </h2>
                                        <div
                                            id={`${index}_wdetails`}
                                            className="accordion-collapse collapse"
                                            aria-labelledby="wdetails"
                                            data-bs-parent="#wdAccordion"
                                        >
                                            <div className="accordion-body p-0">
                                                <div className='import_exportDV'>
                                                    <Row className='up_reco_status storeloc'>
                                                        <Col md={6} className="import_export_dv">
                                                            <div className='import_dv'>
                                                                <h6>Import</h6>
                                                                <Row>
                                                                    <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                        <h4>Breakdown</h4>
                                                                        <Form.Control
                                                                            type="datetime-local"
                                                                            placeholder=""
                                                                            name='breakdown'
                                                                            value={stn.breakdown || ''}
                                                                            disabled={!isEditing}
                                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'breakdown', e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col sm={6} className='reco_left recto_station mb-2'>
                                                                        <h4>Location</h4>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder=""
                                                                            name='location'
                                                                            value={stn.location || ''}
                                                                            disabled={!isEditing}
                                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'location', e.target.value)}
                                                                        />
                                                                    </Col>

                                                                    <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                        <h4>Delivery</h4>
                                                                        <Form.Control
                                                                            type="datetime-local"
                                                                            placeholder=""
                                                                            name='delivery'
                                                                            value={stn.delivery || ''}
                                                                            disabled={!isEditing}
                                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'delivery', e.target.value)}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </Col>
                                                        <Col md={6} className='p-0'>
                                                            <div className='export_dv'>
                                                                <h6>Export</h6>
                                                                <Row>
                                                                    <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                        <h4>Acceptance Time</h4>
                                                                        <Form.Control
                                                                            type="datetime-local"
                                                                            placeholder=""
                                                                            name='acceptance_time'
                                                                            value={stn.acceptance_time || ''}
                                                                            disabled={!isEditing}
                                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'acceptance_time', e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col sm={6} className='reco_left  recto_station mb-2'>
                                                                        <h4>Location</h4>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder=""
                                                                            name='storage_location'
                                                                            value={stn.storage_location || ''}
                                                                            disabled={!isEditing}
                                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'storage_location', e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col sm={12} className='reco_left recto_station'>
                                                                        <h4>Build Up Time</h4>
                                                                        <Form.Control
                                                                            type="datetime-local"
                                                                            placeholder=""
                                                                            name='buildup_time'
                                                                            value={stn.buildup_time || ''}
                                                                            disabled={!isEditing}
                                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'buildup_time', e.target.value)}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </div>

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className='recover_box import_exportDV'>
                                        <Row className='up_reco_status storeloc'>
                                            <Col md={6} className="import_export_dv">
                                                <h6>Import</h6>
                                                <Row>
                                                    <Col sm={6} className='reco_left  recto_station mb-3'>
                                                        <h4>Breakdown</h4>
                                                        <Form.Control
                                                            type="date"
                                                            placeholder=""
                                                            name='breakdown'
                                                            value={stn.breakdown || ''}
                                                            disabled={!isEditing}
                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'breakdown', e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col sm={6} className='reco_left recto_station mb-2'>
                                                        <h4>Location - Temp </h4>
                                                        <Form.Control
                                                            type="date"
                                                            placeholder=""
                                                            name='location'
                                                            value={stn.location || ''}
                                                            disabled={!isEditing}
                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'location', e.target.value)}
                                                        />
                                                    </Col>

                                                    <Col sm={6} className='reco_left  recto_station mb-2'>
                                                        <h4>Delivery</h4>
                                                        <Form.Control
                                                            type="date"
                                                            placeholder=""
                                                            name='delivery'
                                                            value={stn.delivery || ''}
                                                            disabled={!isEditing}
                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'delivery', e.target.value)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md={6}>
                                                <h6>Export</h6>
                                                <Row>

                                                    <Col sm={6} className='reco_left  recto_station mb-3'>
                                                        <h4>Acceptance Time</h4>
                                                        <Form.Control
                                                            type="date"
                                                            placeholder=""
                                                            name='acceptance_time'
                                                            value={stn.acceptance_time || ''}
                                                            disabled={!isEditing}
                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'acceptance_time', e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col sm={6} className='reco_left  recto_station mb-2'>
                                                        <h4>Location - Temp </h4>
                                                        <Form.Control
                                                            type="date"
                                                            placeholder=""
                                                            name='storage_location'
                                                            value={stn.storage_location || ''}
                                                            disabled={!isEditing}
                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'storage_location', e.target.value)}
                                                        />
                                                    </Col>
                                                    <Col sm={12} className='reco_left recto_station'>
                                                        <h4>Build Up Time</h4>
                                                        <Form.Control
                                                            type="date"
                                                            placeholder=""
                                                            name='buildup_time'
                                                            value={stn.buildup_time || ''}
                                                            disabled={!isEditing}
                                                            onChange={(e) => handleFormChange(stn.handler_feedback_id, 'buildup_time', e.target.value)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </div> */}
                                {/* <div>
                                        <Form.Label>Recovery Aspects </Form.Label>
                                        <Form.Group as={Row} className="mb-1">
                                            {stn?.handler_action?.map((aspect, index) => (
                                                <React.Fragment key={index}>
                                                    <Col className='mb-2'>
                                                        <div className='warehose'>
                                                            <Form.Check
                                                                inline
                                                                type="checkbox"
                                                                id={`warehouseCheck${index}`}
                                                                className="warehouse_check"
                                                                label={`Warehouse Check - ${index + 1}`}
                                                                checked={aspect.warehouse_check}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check', e.target.checked)}
                                                            />
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="warehouse_check_date"
                                                                value={aspect.warehouse_check_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'warehouse_check_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col className='mb-2 position-relative'>
                                                        <div className='warehose'>
                                                            <Form.Check
                                                                inline
                                                                type="checkbox"
                                                                id={`contactedAgent${index}`}
                                                                className="warehouse_check"
                                                                label={`Contacted Agent - ${index + 1}`}
                                                                checked={aspect.contacted_agent}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'contacted_agent', e.target.checked)}
                                                            />
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="contacted_agent_date"
                                                                value={aspect.contacted_agent_date}
                                                                disabled={!isEditing}
                                                                onChange={(e) => handleInputChange(stn.handler_feedback_id, index, 'contacted_agent_date', e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </React.Fragment>
                                            ))}
                                        </Form.Group>
                                    </div> */}
                                {/* <div className='recover_box'>
                                        <Row className='up_reco_status storeloc'>
                                            <Col sm={6} className='reco_left  recto_station mb-3'>
                                                <h4>Storage Location</h4>
                                                <Form.Control
                                                    type="text"
                                                    placeholder=""
                                                    name='storage_location'
                                                    value={stn.storage_location || ''}
                                                    disabled={!isEditing}
                                                    onChange={(e) => handleFormChange(stn.handler_feedback_id, 'storage_location', e.target.value)}
                                                />
                                            </Col>
                                            <Col sm={6} className='reco_left  recto_station mb-3'>
                                                <h4>Acceptance Time</h4>
                                                <Form.Control
                                                    type="date"
                                                    placeholder=""
                                                    name='acceptance_time'
                                                    value={stn.acceptance_time || ''}
                                                    disabled={!isEditing}
                                                    onChange={(e) => handleFormChange(stn.handler_feedback_id, 'acceptance_time', e.target.value)}
                                                />
                                            </Col>
                                            <Col sm={6} className='reco_left recto_station'>
                                                <h4>Build Up Time</h4>
                                                <Form.Control
                                                    type="date"
                                                    placeholder=""
                                                    name='buildup_time'
                                                    value={stn.buildup_time || ''}
                                                    disabled={!isEditing}
                                                    onChange={(e) => handleFormChange(stn.handler_feedback_id, 'buildup_time', e.target.value)}
                                                />
                                            </Col>
                                        </Row>
                                    </div> */}
                                {/* <div className='ship_head_wrap'>
                                        <div className='ship_head mb-0 mt-3'>
                                            <h4>Documents Checklist </h4>
                                        </div> */}
                                <div className="accordion ship_head_wrap mt-3" id="documentChecklistAccordion">

                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingDocs">
                                            <button
                                                className="accordion-button collapsed"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#${index}_collapseDocs`}
                                                aria-expanded="false"
                                                aria-controls={`${index}_collapseDocs`}
                                            >
                                                Documents Checklist
                                            </button>
                                        </h2>

                                        <div
                                            id={`${index}_collapseDocs`}
                                            className="accordion-collapse collapse"
                                            aria-labelledby="headingDocs"
                                            data-bs-parent="#documentChecklistAccordion"
                                        >
                                            <div className="accordion-body p-0">
                                                <table className="table">
                                                    <tbody>
                                                        {attHandler.length > 0 && attHandler.map((file, index) => {
                                                            const fileName = file?.file_name;
                                                            // console.log("🚀 ~ {files.map ~ file:", file)
                                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                            const extension = fileName?.split(".").pop();
                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <td>
                                                                            <div key={`ns_${index}`} className=''>
                                                                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                ) ? (
                                                                                    <>
                                                                                        <img
                                                                                            src={file.file_path}
                                                                                            alt="Preview"
                                                                                            style={{
                                                                                                maxWidth: "35px",
                                                                                                maxHeight: "35px",
                                                                                                marginRight: "10px",
                                                                                                backgroundColor: "#F1F1F1",
                                                                                                padding: "9px",
                                                                                                borderRadius: "3px"
                                                                                            }}
                                                                                        // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                        // onClick={() =>
                                                                                        //   handleFileClick(file.file_path)
                                                                                        // }
                                                                                        />
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <span className="">
                                                                                            <img src={Docmnt} className="fileimg" />
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                                <span className="rafilename">
                                                                                    {baseName?.length <= 12 ? fileName : `${baseName?.substring(0, 12)}... .${extension}`}
                                                                                </span>
                                                                                {/* <button
                                                            className="dltbtn"
                                                            type="button"
                                                            onClick={() =>
                                                                handleDeleteImage(index, file.id, file.attachment_type)
                                                            }
                                                        >
                                                            <FontAwesomeIcon icon={faCircleXmark} />
                                                        </button> */}
                                                                            </div>
                                                                        </td>
                                                                        <td className='nrml_text'>{file.category.map(key => cat[key] ?? key)}</td>
                                                                        <td><img src={file_download} alt='file_download' onClick={() => handleDownload(file.file_path, file.file_name)} /></td>
                                                                    </tr>
                                                                </>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    )
                }
                )}
            </Row>
            {/* } */}
        </>
    )
}

export default Stations